import { Card } from '@/components/ui/card/Card';
import { Skeleton } from '@/components/ui/skeleton';

type KeyIndicatorCardProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
  description?: string;
  iconColor?: string;
};

export const KeyIndicatorCard = ({
  icon,
  label,
  value,
  description,
  iconColor = 'text-primary',
}: KeyIndicatorCardProps) => (
  <Card padding="sm" className="group relative overflow-hidden transition-all hover:shadow-md">
    <div className="flex items-start gap-3">
      <div
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-muted/50 transition-colors group-hover:bg-muted ${iconColor}`}
      >
        {icon}
      </div>
      <div className="flex-1 space-y-1">
        <p className="text-xs font-medium text-muted-foreground">{label}</p>
        <p className="text-2xl font-bold tracking-tight">{value}</p>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </div>
    </div>
  </Card>
);

export const KeyIndicatorCardSkeleton = () => (
  <Card padding="sm">
    <div className="flex items-start gap-3">
      <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-7 w-24" />
      </div>
    </div>
  </Card>
);
